import angular from "angular";
import Vue from "vue";
import "ngVue";

import PDFDocumentEditor from "./PDFDocumentEditor.vue";

// Import and register all field components globally for Vue
import SignatureField from "./fields/SignatureField.vue";
import TextField from "./fields/TextField.vue";
import SelectField from "./fields/SelectField.vue";
import DateField from "./fields/DateField.vue";
import BaseField from "./fields/BaseField.vue";

// Import and register vue-signature-pad globally to avoid Vue.component issues
import VueSignaturePad from "vue-signature-pad";
Vue.use(VueSignaturePad);

Vue.component("SignatureField", SignatureField);
Vue.component("TextField", TextField);
Vue.component("SelectField", SelectField);
Vue.component("DateField", DateField);
Vue.component("BaseField", BaseField);

// Register PDFDocumentEditor globally at module load time
const PdfDocumentEditorComponent = Vue.component("PdfDocumentEditor", PDFDocumentEditor);

export default angular
  .module("admin.directives.documenteditor", ["ngVue"])
  .directive("pdfDocumentEditor", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(PdfDocumentEditorComponent);
    },
  ]);
